module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921091149_T.a53d3ae8.jpg";